import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=beb02e56&scoped=true"
import script from "./welfare.vue?vue&type=script&lang=js"
export * from "./welfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb02e56",
  null
  
)

export default component.exports